// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"e2e512f1","3770":"82b13971","3888":"b32aa2a7","4921":"9ecd7837","5400":"b219f08d","7996":"8077014a","9131":"8615300f"}[chunkId] + ".chunk.js";
};